module.exports = __webpack_public_path__ + "media/hôie.104eaa6d.mp3";